import { render, staticRenderFns } from "./TalentFileView.vue?vue&type=template&id=d22d63ec"
import script from "./TalentFileView.vue?vue&type=script&lang=ts"
export * from "./TalentFileView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports